import axios from "axios";
import { API_URL } from "./config";

const axiosConfig = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosConfig.interceptors.request.use(function (config) {
  let token = localStorage.getItem("businessToken");
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});
axiosConfig.interceptors.response.use(
  (res) => {
    return res;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosConfig;
